import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format } from "date-fns";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CloseTemplateRow } from "../organizationCloseTemplatesViewConfig";

export const CloseTemplateUpdatedCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CloseTemplateRow, Date>) => (
        <ViewTableCell>
            <span>{format(row.original.updatedAt, "MMM d, yyyy")}</span>
        </ViewTableCell>
    ),
);
